import { render } from "./home.vue?vue&type=template&id=1fda23ae&scoped=true&ts=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"

import "./home.vue?vue&type=style&index=0&id=1fda23ae&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fda23ae"]])

export default __exports__